/* unplugin-vue-components disabled */
import {API2_ENRICH} from 'consts/api2'
import Rest from 'utils/rest'

export default {
  inject: {
    // Expecting: Map<string, object>
    di_apollo: {
      from: 'di_apollo',
      default: undefined
    }
  },
  props: {
    text: {
      type: String,
      required: true, 
    },
    href: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      rest: new Rest(),
      type: undefined,
      apollo_id: undefined,
      linkedin: undefined,
      has_email: false,
      has_phone: false,
    }
  },
  computed:{
    first_name(){
      const [name] = this.text.split(' ')
      return name
    },
    info_title(){
      if (this.type === 'company') return this.text + ' Company Info'
      return this.first_name + '\'s Contact Info'
    },
    c_email(){
      return this.di_apollo?.get(this.href)?.email
    },
    c_phone(){
      return this.di_apollo?.get(this.href)?.contact?.phone_numbers?.[0]?.raw_number ||
          this.di_apollo?.get(this.href)?.contact?.phone_numbers?.[0]?.sanitized_number ||
          this.di_apollo?.get(this.href)?.organization?.primary_phone?.sanitized_number
    },
    icon_size(){
      return this.$responsive.mobile ? '2rem' : '1.6rem'
    },
    email_field(){
      return this.has_email || !!this.c_email
    },
    phone_field(){
      return this.has_phone || !!this.c_phone
    }
  },
  mounted(){
    const url = new URL(this.href)

    this.type = url.hostname
    this.apollo_id = url.searchParams.get('apollo_id')

    const linkedin_id = url.searchParams.get('linkedin_id')
    if (linkedin_id) {
      const linkedin_type = this.type === 'person' ? 'in' : 'company'
      this.linkedin = `https://linkedin.com/${linkedin_type}/${linkedin_id}`
    }

    const has_email = url.searchParams.get('has_email') === 'true'
    const has_phone = url.searchParams.get('has_phone') === 'true'

    if (has_email)  this.has_email = true
    if (has_phone) this.has_phone = true
  },
  beforeUnmount(){
    this.rest.abortAll()
  },
  methods: {
    async getContactInfo() {
      this.loading = true
      try {
        const apollo_data = await this.rest.get(`${API2_ENRICH}/${this.type}/${this.apollo_id}`)
        this.di_apollo?.set(this.href, apollo_data)
      } catch(err) {
        $utils.toasts.error(`Unable to load contact info: ${err}`)
      }
      this.loading = false
    },
    onEmail(){
      if (this.c_email) this.$throttle_1000(this.copyEmail)
      else this.getContactInfo()
    },
    onPhone(){
      if (this.c_phone) this.$throttle_1000(this.copyPhone)
      else this.getContactInfo()
    },
    async copyEmail(){
      await $utils.copyText(this.c_email)
      const message = this.type === 'person' 
        ? `${this.first_name}'s email copied to clipboard` 
        : `${this.text} email copied to clipboard`
      $utils.toasts.success(message)
    },
    async copyPhone(){
      await $utils.copyText(this.c_phone)
      const message = this.type === 'person' 
        ? `${this.first_name}'s number copied to clipboard`
        : `${this.text}'s number copied to clipboard`
      $utils.toasts.success(message)
    },
    openLinkedin(){
      $utils.openLink(this.linkedin)
    }
  }
}
